const styles = theme => ({
  leftContainer: {
    padding: theme.spacing(2),
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },

  rightContainer: {
    padding: theme.spacing(2),
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  textfieldText: {
    color: "black"
  },
  title: {
    color: theme.palette.primary.default,
    fontWeight: "bold",
    fontSize: "18px"
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  image: {
    display: "block",
    margin: "0 auto",
    height: "350px"
  },
  cardMedia: {
    position: "relative",
    display: "flex",
    justifyContent: "center"
  },
  iconContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  playIcon: {
    color: "#fff",
    fontSize: "100px"
  },
  textContainer: {
    whiteSpace: "pre-wrap",
    marginTop: theme.spacing(2),
    color: "#676767"
  },
  author: {
    marginTop: theme.spacing(2)
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/Email/styles.js